import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Swal from "sweetalert2";

const PoliciesTaxes = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/event-company-profile"
        );
        setData(response.data);
        setError(null); // Clear any previous errors
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    // Fetch data every second
    const intervalId = setInterval(fetchData, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  const [formData, setFormData] = useState({
    taxValue: "",
  });
  const [termsConditionsOne, setTermsConditionsOne] = useState("");
  const [termsConditionsTwo, setTermsConditionsTwo] = useState("");
  const [termsConditionsThree, setTermsConditionsThree] = useState("");
  const [paymentPolicy, setPaymentPolicy] = useState("");
  const [cancellationPolicy, setCancellationPolicy] = useState("");

  const [termsConditionsCheckOne, setTermsConditionsCheckOne] = useState(false);
  const [termsConditionsCheckTwo, setTermsConditionsCheckTwo] = useState(false);
  const [termsConditionsCheckThree, setTermsConditionsCheckThree] =
    useState(false);

  const handleAddClickTCone = () => {
    setTermsConditionsCheckOne(true);
  };

  const handleRemoveClickTCone = () => {
    setTermsConditionsCheckOne(false);
  };

  const handleAddClickTCtwo = () => {
    setTermsConditionsCheckTwo(true);
  };

  const handleRemoveClickTCtwo = () => {
    setTermsConditionsCheckTwo(false);
  };

  const handleAddClickTCthree = () => {
    setTermsConditionsCheckThree(true);
  };

  const handleRemoveClickTCthree = () => {
    setTermsConditionsCheckThree(false);
  };


  const companyId = "678363fef3dff9528dc37bfa";

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const dataToSend = {
      companyId,
      termsConditionsOne,
      termsConditionsTwo,
      termsConditionsThree,
      termsConditionsCheckOne,
      termsConditionsCheckTwo,
      termsConditionsCheckThree,
      paymentPolicy,
      cancellationPolicy,
      taxValue: formData.taxValue,
    };

    // SweetAlert2 confirmation dialog
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You are about to update the terms and conditions. This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    });

    // If user confirms, proceed with the fetch request
    if (result.isConfirmed) {
      try {
        const response = await fetch(
          `https://server-gs.vercel.app/event-term-condition-update/${companyId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToSend),
          }
        );

        if (response.ok) {
          Swal.fire(
            "Updated!",
            "Your terms and conditions have been updated.",
            "success"
          );
        } else {
          Swal.fire(
            "Failed!",
            "There was a problem updating your terms and conditions.",
            "error"
          );
        }
      } catch (error) {
        console.error("Error updating form:", error);
        Swal.fire(
          "Error!",
          "There was an error updating your terms and conditions.",
          "error"
        );
      }
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="p-5 min-h-screen pb-20 ">
      <div className="bg-blue-50 min-h-screen">
        <div className="flex flex-col gap-5">
          <div className="bg-white">
            <div className="flex justify-between w-full px-5 pt-5 border-b border-b-gray-200 pb-4">
              <div>
                <h1 className="text-2xl font-roboto font-semibold text-gray-700">
                  Company Details
                </h1>
              </div>
            </div>
            <div className="flex justify-between ">
              <div className="p-5">
                <p className="text-xl font-roboto text-gray-600">
                  <strong>Name:</strong> {data?.CompanyName || "N/A"}
                </p>

                <p className="text-xl font-roboto text-gray-600">
                  <strong>Website:</strong>{" "}
                  {data?.websiteUrl ? (
                    <a
                      href={data?.websiteUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {data?.websiteUrl}
                    </a>
                  ) : (
                    "N/A"
                  )}
                </p>
                <p className="text-xl font-roboto text-gray-600">
                  <strong>Phone:</strong> {data?.phone || "N/A"}
                </p>
                <p className="text-xl font-roboto text-gray-600">
                  <strong>Address:</strong> {data?.address || "N/A"}
                </p>
              </div>
              <div className="p-5">
                <p className="text-xl font-roboto text-gray-600">
                  <strong>Company ID:</strong> {data?.CompanyId || "N/A"}
                </p>
                <p className="text-xl font-roboto text-gray-600">
                  <strong>Type:</strong> {data?.CompanyType || "Not specified"}
                </p>
                <p className="text-xl font-roboto text-gray-600">
                  <strong>Description:</strong>{" "}
                  {data?.CompanyDes || "No description available"}
                </p>
              </div>

              <div className="w-24 h-24  m-5">
                <img
                  class="w-24 h-24 object-cover rounded"
                  src={data?.CompanyLogo}
                  alt="Default avatar"
                ></img>
              </div>
            </div>
          </div>
          <form onSubmit={handleSubmit}>
            {/* Terms & Conditions */}
            <div className="mt-5 bg-white flex flex-col">
              <div className="flex justify-between w-full px-5 pt-5 border-b border-b-gray-200 pb-4">
                <div className="flex flex-row gap-5 items-center">
                  <h1 className="text-2xl font-roboto font-semibold text-gray-700">
                    Terms & Conditions One
                  </h1>
                  <p className="text-gray-700">
                    {data.termsConditionsCheckOne ? (
                      <span className="flex items-center text-green-600">
                        <svg
                          className="w-4 h-4 mr-1"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Added to invoice
                      </span>
                    ) : (
                      <span className="flex items-center text-red-600">
                        <svg
                          className="w-4 h-4 mr-1"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Not added to invoice
                      </span>
                    )}
                  </p>
                </div>
                <div>
                  {data.termsConditionsCheckOne === true ? (
                    <button
                      onClick={handleRemoveClickTCone}
                      className="flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors"
                    >
                      <svg
                        className="w-5 h-5 mr-2"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                          fill="currentColor"
                        />
                      </svg>
                      Remove from invoice
                    </button>
                  ) : (
                    <button
                      onClick={handleAddClickTCone}
                      className="flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-green-500 rounded-lg hover:bg-green-600 transition-colors"
                    >
                      <svg
                        className="w-5 h-5 mr-2"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                          fill="currentColor"
                        />
                      </svg>
                      Add to invoice
                    </button>
                  )}
                </div>
              </div>
              <div className="flex justify-between py-10">
                <div className="w-[50%] px-5">
                  <p className="text-md font-roboto text-gray-600 text-justify">
                    {data?.termsConditionsOne ? (
                      <div
                        className="text-justify"
                        dangerouslySetInnerHTML={{
                          __html: data.termsConditionsOne,
                        }}
                      ></div>
                    ) : (
                      ""
                    )}
                  </p>
                </div>
                <div className="w-[50%] pr-5 flex flex-col gap-1">
                  <label className="font-roboto text-xl text-gray-900">
                    Add terms and conditions one
                  </label>
                  <ReactQuill
                    value={termsConditionsOne}
                    onChange={setTermsConditionsOne}
                    placeholder="Write your terms and conditions here..."
                    className="custom-editor"
                  />
                </div>
              </div>
            </div>
            <div className="mt-5 bg-white flex flex-col">
              <div className="flex justify-between w-full px-5 pt-5 border-b border-b-gray-200 pb-4">
              <div className="flex flex-row gap-5 items-center">
                  <h1 className="text-2xl font-roboto font-semibold text-gray-700">
                    Terms & Conditions Two
                  </h1>
                  <p className="text-gray-700">
                    {data.termsConditionsCheckTwo ? (
                      <span className="flex items-center text-green-600">
                        <svg
                          className="w-4 h-4 mr-1"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Added to invoice
                      </span>
                    ) : (
                      <span className="flex items-center text-red-600">
                        <svg
                          className="w-4 h-4 mr-1"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Not added to invoice
                      </span>
                    )}
                  </p>
                </div>
                <div>
                  {data.termsConditionsCheckTwo === true ? (
                    <button
                      onClick={handleRemoveClickTCtwo}
                      className="flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors"
                    >
                      <svg
                        className="w-5 h-5 mr-2"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                          fill="currentColor"
                        />
                      </svg>
                      Remove from invoice
                    </button>
                  ) : (
                    <button
                      onClick={handleAddClickTCtwo}
                      className="flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-green-500 rounded-lg hover:bg-green-600 transition-colors"
                    >
                      <svg
                        className="w-5 h-5 mr-2"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                          fill="currentColor"
                        />
                      </svg>
                      Add to invoice
                    </button>
                  )}
                </div>
              </div>
              <div className="flex justify-between py-10">
                <div className="w-[50%] px-5">
                  <p className="text-md font-roboto text-gray-600 text-justify">
                    {data?.termsConditionsTwo ? (
                      <div
                        className="text-justify"
                        dangerouslySetInnerHTML={{
                          __html: data.termsConditionsTwo,
                        }}
                      ></div>
                    ) : (
                      ""
                    )}
                  </p>
                </div>
                <div className="w-[50%] pr-5 flex flex-col gap-1">
                  <label className="font-roboto text-xl text-gray-900">
                    Add terms and conditions two
                  </label>
                  <ReactQuill
                    value={termsConditionsTwo}
                    onChange={setTermsConditionsTwo}
                    placeholder="Write your terms and conditions here..."
                    className="custom-editor"
                  />
                </div>
              </div>
            </div>
            <div className="mt-5 bg-white flex flex-col">
              <div className="flex justify-between w-full px-5 pt-5 border-b border-b-gray-200 pb-4">
              <div className="flex flex-row gap-5 items-center">
                  <h1 className="text-2xl font-roboto font-semibold text-gray-700">
                    Terms & Conditions Three
                  </h1>
                  <p className="text-gray-700">
                    {data.termsConditionsCheckThree ? (
                      <span className="flex items-center text-green-600">
                        <svg
                          className="w-4 h-4 mr-1"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Added to invoice
                      </span>
                    ) : (
                      <span className="flex items-center text-red-600">
                        <svg
                          className="w-4 h-4 mr-1"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Not added to invoice
                      </span>
                    )}
                  </p>
                </div>
                <div>
                  {data.termsConditionsCheckThree === true ? (
                    <button
                      onClick={handleRemoveClickTCthree}
                      className="flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors"
                    >
                      <svg
                        className="w-5 h-5 mr-2"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                          fill="currentColor"
                        />
                      </svg>
                      Remove from invoice
                    </button>
                  ) : (
                    <button
                      onClick={handleAddClickTCthree}
                      className="flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-green-500 rounded-lg hover:bg-green-600 transition-colors"
                    >
                      <svg
                        className="w-5 h-5 mr-2"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                          fill="currentColor"
                        />
                      </svg>
                      Add to invoice
                    </button>
                  )}
                </div>
              </div>
              <div className="flex justify-between py-10">
                <div className="w-[50%] px-5">
                  <p className="text-md font-roboto text-gray-600 text-justify">
                    {data?.termsConditionsThree ? (
                      <div
                        className="text-justify"
                        dangerouslySetInnerHTML={{
                          __html: data.termsConditionsThree,
                        }}
                      ></div>
                    ) : (
                      ""
                    )}
                  </p>
                </div>
                <div className="w-[50%] pr-5 flex flex-col gap-1">
                  <label className="font-roboto text-xl text-gray-900">
                    Add terms and conditions three
                  </label>
                  <ReactQuill
                    value={termsConditionsThree}
                    onChange={setTermsConditionsThree}
                    placeholder="Write your terms and conditions here..."
                    className="custom-editor"
                  />
                </div>
              </div>
            </div>

            {/* Payment Policy */}
            <div className="mt-5 bg-white flex flex-col">
              <div className="flex justify-between w-full px-5 pt-5 border-b border-b-gray-200 pb-4">
                <h1 className="text-2xl font-roboto font-semibold text-gray-700">
                  Payment Policy
                </h1>
              </div>
              <div className="flex justify-between py-10">
                <div className="w-[50%] px-5">
                  <p className="text-md font-roboto text-gray-600 text-justify">
                    {data?.paymentPolicy ? (
                      <div
                        className="text-justify"
                        dangerouslySetInnerHTML={{
                          __html: data.paymentPolicy,
                        }}
                      ></div>
                    ) : (
                      ""
                    )}
                  </p>
                </div>
                <div className="w-[50%] px-5 flex flex-col gap-1">
                  <label className="font-roboto text-xl text-gray-900">
                    Add payment policy
                  </label>
                  <ReactQuill
                    value={paymentPolicy}
                    onChange={setPaymentPolicy}
                    placeholder="Write your payment policy here..."
                    className="custom-editor"
                  />
                </div>
              </div>
            </div>

            {/* Cancellation Policy */}
            <div className="mt-5 bg-white flex flex-col">
              <div className="flex justify-between w-full px-5 pt-5 border-b border-b-gray-200 pb-4">
                <h1 className="text-2xl font-roboto font-semibold text-gray-700">
                  General Cancellation Policy
                </h1>
              </div>
              <div className="flex justify-between py-10">
                <div className="w-[50%] px-5">
                  <p className="text-md font-roboto text-gray-600 text-justify">
                    {data?.cancellationPolicy ? (
                      <div
                        className="text-justify"
                        dangerouslySetInnerHTML={{
                          __html: data.cancellationPolicy,
                        }}
                      ></div>
                    ) : (
                      ""
                    )}
                  </p>
                </div>
                <div className="w-[50%] flex flex-col gap-1">
                  <label className="font-roboto text-xl text-gray-900">
                    Add General Cancellation Policy
                  </label>
                  <ReactQuill
                    value={cancellationPolicy}
                    onChange={setCancellationPolicy}
                    placeholder="Write your cancellation policy here..."
                    className="custom-editor"
                  />
                </div>
              </div>
            </div>

            {/* Add TAX */}
            <div className="mt-5 bg-white flex flex-col">
              <div className="flex justify-between w-full px-5 pt-5 border-b border-b-gray-200 pb-4">
                <h1 className="text-2xl font-roboto font-semibold text-gray-700">
                  Add TAX
                </h1>
              </div>
              <div className="flex justify-between py-10">
                <div className="w-[50%] px-5">
                  <h1 className="font-roboto text-xl text-gray-900">
                    TAX Value: {data?.taxValue} %
                  </h1>
                </div>
                <div className="w-[50%] flex flex-col">
                  <label className="font-roboto text-xl text-gray-900">
                    Add TAX value
                  </label>
                  <input
                    type="text"
                    name="taxValue"
                    value={formData.taxValue}
                    onChange={handleChange}
                    className="border border-gray-300 p-2 rounded-lg w-[60%]"
                    placeholder="Enter TAX value"
                  />
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="mt-5">
              <button
                type="submit"
                className="px-5 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PoliciesTaxes;
